'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'badge-check';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f336';
var svgPathData = ['M48 256c0 24.1 13.5 45.1 33.5 55.7L99.1 321l-5.8 19c-6.6 21.6-1.4 46.1 15.7 63.1s41.5 22.3 63.1 15.7l19-5.8 9.3 17.5c10.6 20 31.6 33.5 55.7 33.5s45.1-13.5 55.7-33.5l9.3-17.5 19 5.8c21.6 6.6 46.1 1.4 63.1-15.7s22.3-41.5 15.7-63.1l-5.8-19 17.5-9.3c20-10.6 33.5-31.6 33.5-55.7s-13.5-45.1-33.5-55.7L412.9 191l5.8-19c6.6-21.6 1.4-46.1-15.7-63.1S361.6 86.6 340 93.2l-19 5.8-9.3-17.5C301.1 61.5 280.1 48 256 48s-45.1 13.5-55.7 33.5L191 99.1l-19-5.8c-21.6-6.6-46.1-1.4-63.1 15.7S86.6 150.4 93.2 172l5.8 19-17.5 9.3C61.5 210.9 48 231.9 48 256zm79 1L161 223l63 63L351 159 385 193 241 337l-17 17-17-17-80-80z', 'M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5L321 99.1l19-5.8c21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1l-5.8 19 17.5 9.3c20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7L412.9 321l5.8 19c6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7l-19-5.8-9.3 17.5c-10.6 20-31.6 33.5-55.7 33.5s-45.1-13.5-55.7-33.5L191 412.9l-19 5.8c-21.6 6.6-46.1 1.4-63.1-15.7S86.6 361.6 93.2 340l5.8-19-17.5-9.3C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7L99.1 191l-5.8-19c-6.6-21.6-1.4-46.1 15.7-63.1S150.4 86.6 172 93.2l19 5.8 9.3-17.5zM256 0c-35.9 0-67.8 17-88.1 43.4c-33-4.3-67.6 6.2-93 31.6s-35.9 60-31.6 93C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6C188.2 495 220.1 512 256 512s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93C495 323.8 512 291.9 512 256s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93s-60-35.9-93-31.6C323.8 17 291.9 0 256 0zM241 337L385 193 351 159l-127 127-63-63L127 257l80 80 17 17 17-17z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBadgeCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;